<div class="d-flex flex-wrap flex-column layers-legend-container gap-2">
	<div class="d-flex justify-content-center align-items-center gap-2">
		@if (this.getLayersAsOptions().length > 1) {
			<app-select
				[label]="selectLabel"
				[selectElementId]="selectElementId"
				[options]="this.getLayersAsOptions()"
				(optionSelected)="this.onSelectOption($event)"></app-select>
		} @else {
			<h6 class="mb-0">
				{{
					this.getLayersAsOptions().length == 1
						? this.getLayersAsOptions()[0].label
						: 'Nessun layer disponibile'
				}}
			</h6>
		}
		@if (showModal) {
			<app-info-button [modalId]="modalId"></app-info-button>
		}
	</div>
	<div>
		<app-legend [items]="selectedLayer.legend"></app-legend>
	</div>
</div>
